import { EditFilled, InfoCircleOutlined, UserOutlined } from "@ant-design/icons";
import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import {
  Avatar,
  Button,
  Col,
  Form,
  Input,
  message,
  Row,
  Tooltip,
  Upload
} from "antd";
import ImgCrop from "antd-img-crop";
import React, { useEffect, useState } from "react";
import SanattestLogo from "../../../Assets/Images/logo.png";
import SanattestIcon from "../../../Assets/Images/small_logo.png";
import { onFileUpload } from "../../../Components/Helper/MediaUploader";
import { Loader } from "../../../Components/Loader";
import { UPDATE_BUSINESS_BY_OWNER } from "../../../Graphql/mutations";
import {
  GET_BUSINESS_BY_OWNER,
  VALIDATE_REFCODE
} from "../../../Graphql/queries";
import "./BusinessInformation.less";

const { REACT_APP_ASSETS_URL } = process.env;

export const BusinessInformationPage = () => {
  const owner_id = localStorage.getItem("user_id");
  const [logoImage, setLogoImage] = useState("");
  const [iconImage, setIconImage] = useState("");
  const [form] = Form.useForm();
  const [GET_BUSINESS_BY_OWNER_QUERY, { data, loading}] =
    useLazyQuery(GET_BUSINESS_BY_OWNER, {
      fetchPolicy: "cache-and-network",
    });
  const [
    UPDATE_BUSINESS_BY_OWNER_MUTATION
  ] = useMutation(UPDATE_BUSINESS_BY_OWNER);
  const { data: validateRefData } = useQuery(VALIDATE_REFCODE, {
    fetchPolicy: "cache-and-network",
    context: {
      headers: {
        subscription: 1,
      },
    },
  });
  useEffect(() => {
    GET_BUSINESS_BY_OWNER_QUERY({
      variables: {
        owner_id,
      },
    });
  }, [GET_BUSINESS_BY_OWNER_QUERY, owner_id]);
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        business_name: data.business[0]?.business_name,
        ref_code: data.business[0]?.ref_code,
        business_type: data.business[0]?.business_type.business_type_description
          ? data.business[0]?.business_type.business_type_name +
            " (" +
            data.business[0]?.business_type.business_type_description +
            ")"
          : data.business[0]?.business_type.business_type_name,
      });
      setLogoImage(data.business[0]?.brand_logo);
      setIconImage(data.business[0]?.brand_icon);
    }
  }, [data]);
  const submitBussiness = async (values) => {
    const refIndex = validateRefData.agent.findIndex(
      (itm) => itm.ref_code === values?.ref_code
    );
    if (refIndex < 0 && values?.ref_code) {
      message.error("Invalid Referral Code...");
      return;
    }
    const { data } = await UPDATE_BUSINESS_BY_OWNER_MUTATION({
      variables: {
        brand_logo: logoImage,
        brand_icon: iconImage,
        owner_id: owner_id,
        business_name: values.business_name,
        ref_code: values.ref_code,
      },
    });
    if (data) {
      message.success("Business information updated successfully!");
    }
  };
  const returnUploadedIcons = (e) => {
    setIconImage(e);
  };
  const returnUploadedLogo = (e) => {
    setLogoImage(e);
  };
  const onFileUploadClick = (e, returnFunc) => {
    onFileUpload(e, "bussinessImage", returnFunc);
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <div>
      <div className="secSubTitle pageSubTilte">
        <div className="stLeft">
          <h5 className="">Business Information</h5>
        </div>
      </div>
      <Form
        form={form}
        className="pt-md-5  businessInfoUpdated"
        name="bussiness-edit"
        onFinish={submitBussiness}
      >
        <Row gutter={40} className="mb-3">
          <Col xs={24} sm={24} md={12} xl={12}>
            <Tooltip
              trigger={["focus"]}
              title="Brand Icon"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item name="brand_icon" noStyle>
                <div className="smallBrandLogo position-relative ">
                  <div className="logoTxt">Icon</div>
                  {!iconImage ? (
                    <Avatar size={80} className="userAvatar">
                      <img src={SanattestIcon} width={50} />
                    </Avatar>
                  ) : (
                    <Avatar
                      src={REACT_APP_ASSETS_URL + iconImage}
                      size={80}
                      className="userAvatar"
                    ></Avatar>
                  )}
                  <ImgCrop
                    zoom={false}
                    modalOk={"Crop"}
                    modalTitle={"Crop Image"}
                  >
                    <Upload
                      showUploadList={false}
                      customRequest={(e) =>
                        onFileUploadClick(e, returnUploadedIcons)
                      }
                    >
                      <Button
                        type="primary"
                        className="editButton"
                        icon={<EditFilled />}
                      ></Button>
                    </Upload>
                  </ImgCrop>
                </div>
              </Form.Item>
            </Tooltip>
          </Col>
          <Col xs={24} sm={24} md={12} xl={12}>
            <Tooltip
              trigger={["focus"]}
              title="Brand Logo"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item name="brand_logo">
                <div className="bigBrandLogo position-relative ">
                  <div className="logoTxt">Brand logo</div>
                  {!logoImage ? (
                    <Avatar size={150} className="userAvatar">
                      <img src={SanattestLogo} width={120} />
                    </Avatar>
                  ) : (
                    <Avatar
                      src={REACT_APP_ASSETS_URL + logoImage}
                      icon={<UserOutlined />}
                      size={150}
                      className="userAvatar"
                    ></Avatar>
                  )}
                  <ImgCrop
                    zoom={false}
                    modalOk={"Crop"}
                    modalTitle={"Crop Image"}
                    quality={1}
                    aspect={3}
                  >
                    <Upload
                      showUploadList={false}
                      customRequest={(e) =>
                        onFileUploadClick(e, returnUploadedLogo)
                      }
                    >
                      <Button
                        type="primary"
                        className="editButton"
                        icon={<EditFilled />}
                      ></Button>
                    </Upload>
                  </ImgCrop>
                </div>
              </Form.Item>
            </Tooltip>
          </Col>
          <Col xs={24} sm={24} xl={24}>
            <label className="mb-2 ml-1 text-black">Business Name</label>
          </Col>
          <Col xs={24} sm={24} xl={24}>
            <Tooltip
              trigger={["focus"]}
              title="Bussiness Name"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item
                name="business_name"
                rules={[
                  {
                    required: true,
                    message: "Please input your bussiness name!",
                    whitespace: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Tooltip>
          </Col>
          <Col xs={24} sm={24} xl={24}>
            <label className="mb-2 ml-1 text-black">Business Type</label>
          </Col>
          <Col xs={24} sm={24} xl={24}>
            <Tooltip
              trigger={["focus"]}
              title="Bussiness Type"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item name="business_type">
                <Input readOnly />
              </Form.Item>
            </Tooltip>
          </Col>
          <Col xs={24} sm={24} xl={24}>
            <label className="mb-2 ml-1 text-black">
              Referral Code{" "}
              <Tooltip
                placement="topLeft"
                title="If you have our Sanattest sales agent referral code or some other Sanattest user has referred you, please enter here."
              >
                <InfoCircleOutlined />
              </Tooltip>
            </label>
          </Col>
          <Col xs={24} sm={24} xl={24}>
            <Tooltip
              trigger={["focus"]}
              title="Referral Code"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item name="ref_code">
                <Input />
              </Form.Item>
            </Tooltip>
          </Col>
          <Col xs={24} sm={24} xl={24}>
            <Form.Item className="text-center">
              <Button
                type="primary"
                shape="round"
                size="large"
                success
                htmlType="submit"
              >
                Update
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
